/**
 * Recently viewed products — pure localStorage, no backend.
 * Stores up to 10 product slugs + minimal metadata for instant display.
 */
const KEY = "recently_viewed_v1";
const MAX = 10;

export function trackView(product) {
  if (!product || !product.slug) return;
  const item = {
    slug: product.slug,
    id: product.id,
    name: typeof product.name === "object" ? (product.name.fr || product.name.en || "") : product.name,
    image: (product.images && product.images[0]) || null,
    price: product.price,
    ts: Date.now(),
  };
  let list = [];
  try { list = JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { list = []; }
  list = list.filter((x) => x.slug !== item.slug);
  list.unshift(item);
  list = list.slice(0, MAX);
  try { localStorage.setItem(KEY, JSON.stringify(list)); } catch { /* ignore */ }
}

export function getRecentlyViewed(excludeSlug) {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || "[]");
    return excludeSlug ? list.filter((x) => x.slug !== excludeSlug) : list;
  } catch {
    return [];
  }
}

export function clearRecentlyViewed() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
